export default __webpack_public_path__ + "static/media/logout-icon.c3f8b6bd.svg";